/**
 * A page's linework only (no text, no images), for drawing over the live
 * viewer while a viewport is framed: the title block, borders, north arrow,
 * scale bar… show where they will cover the plan.
 */

import type { DisplayItem, DisplayPage } from '@pointorama/print-engine';
import type { PreviewEnv } from './usePreviewEnv';

/** Where a viewport sits on its page (mm) and the page's lines around it. */
export interface PageLines {
  svg: string;
  pageWidthMm: number;
  pageHeightMm: number;
  /** The framed viewport's top-left on the page. */
  viewportXmm: number;
  viewportYmm: number;
}

function linesOnly(items: readonly DisplayItem[]): DisplayItem[] {
  const out: DisplayItem[] = [];
  for (const item of items) {
    if (item.type === 'path') {
      if (item.stroke) out.push({ ...item, fill: null });
    } else if (item.type === 'group') {
      const children = linesOnly(item.items);
      if (children.length > 0) out.push({ ...item, items: children });
    }
  }
  return out;
}

/** SVG of the page's strokes (fills, text and images left out), transparent background. */
export function pageLinesSvg(env: PreviewEnv, page: DisplayPage): string {
  return env.engine.renderSvg({ ...page, items: linesOnly(page.items) }, { font: env.svgFont, imageHref: () => null, idPrefix: 'pl' });
}
